// FAQ Search - Auto-expand matching collapsible tabs with highlighting
(function() {
  // Wait for page to load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    // Find the search input
    const searchInput = document.querySelector('.faq-search__input');
    const collapsibleTabs = document.querySelectorAll('.collapsible-tabs__tab details');
    
    if (!searchInput || collapsibleTabs.length === 0) {
      console.log('FAQ Search: Could not find search input or collapsible tabs');
      return;
    }
    
    console.log('FAQ Search: Initialized successfully');
    
    // Add CSS for highlighting
    addHighlightStyles();
    
    searchInput.addEventListener('input', function(e) {
      const searchTerm = e.target.value.toLowerCase().trim();
      
      // If search is empty, close all tabs, remove highlights, and show all tabs
      if (searchTerm === '') {
        collapsibleTabs.forEach(tab => {
          tab.removeAttribute('open');
          tab.style.display = 'block';
          removeHighlights(tab);
        });
        return;
      }
      
      // Search through all tabs
      collapsibleTabs.forEach(tab => {
        const titleElement = tab.querySelector('.disclosure__title');
        const contentElement = tab.querySelector('.disclosure__content');
        
        const title = titleElement?.textContent.toLowerCase() || '';
        const content = contentElement?.textContent.toLowerCase() || '';
        
        // If search term matches title or content, open the tab and highlight
        if (title.includes(searchTerm) || content.includes(searchTerm)) {
          tab.setAttribute('open', '');
          tab.style.display = 'block';
          
          // Highlight matching text
          highlightText(titleElement, searchTerm);
          highlightText(contentElement, searchTerm);
        } else {
          tab.removeAttribute('open');
          tab.style.display = 'none';
          removeHighlights(tab);
        }
      });
    });
  }
  
  // Function to add highlight styles to the page
  function addHighlightStyles() {
    if (document.getElementById('faq-search-highlight-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'faq-search-highlight-styles';
    style.textContent = '.faq-search-highlight { background-color: #789C4A; color: #000; padding: 2px 4px; border-radius: 2px; font-weight: 600; }';
    document.head.appendChild(style);
  }
  
  // Function to highlight matching text
  function highlightText(element, searchTerm) {
    if (!element) return;
    
    // Remove existing highlights first
    removeHighlights(element);
    
    // Get the original HTML
    const originalHTML = element.innerHTML;
    
    // Create a regex to find the search term (case insensitive)
    const escapedTerm = escapeRegex(searchTerm);
    const regex = new RegExp('(' + escapedTerm + ')', 'gi');
    
    // Replace matches with highlighted version
    const highlightedHTML = originalHTML.replace(regex, '<mark class="faq-search-highlight">$1</mark>');
    
    element.innerHTML = highlightedHTML;
  }
  
  // Function to remove highlights
  function removeHighlights(container) {
    if (!container) return;
    
    const highlights = container.querySelectorAll('.faq-search-highlight');
    highlights.forEach(highlight => {
      const parent = highlight.parentNode;
      parent.replaceChild(document.createTextNode(highlight.textContent), highlight);
      parent.normalize();
    });
  }
  
  // Escape special regex characters
  function escapeRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
})();